var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from "@angular/core";
import { ContentBaseService } from "../../../../component/base/contentbase.service";
import { NGXLogger } from "ngx-logger";
import { ApiService } from "../../../../service/api.service";
var KtsMaintenanceReceptionTimeService = /** @class */ (function (_super) {
    __extends(KtsMaintenanceReceptionTimeService, _super);
    function KtsMaintenanceReceptionTimeService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    KtsMaintenanceReceptionTimeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsMaintenanceReceptionTimeService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsMaintenanceReceptionTimeService;
}(ContentBaseService));
export { KtsMaintenanceReceptionTimeService };
var MaintenanceReceptionTimeTemplate = /** @class */ (function () {
    function MaintenanceReceptionTimeTemplate() {
    }
    return MaintenanceReceptionTimeTemplate;
}());
export { MaintenanceReceptionTimeTemplate };
//# sourceMappingURL=maintenance-reception-time.service.js.map